import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faTimes,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import {
  SearchContainer,
  SearchComponent,
  HeaderSearchComponent,
  ButtonContainer,
  SearchBox,
  CrossBox,
} from './search-components';

type Props = {
  placeholder?: string;
  value: string;
  onValueChange: (e: any) => void;
  onClear?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  variant?: 'large' | 'medium' | 'small' | 'header';
  onKeyUp?: (e: any) => void;
  autoSearch?: boolean;
  isHeaderSearch?: boolean;
  submitSearch?: (e: any) => void;
};

export default function Search({
  placeholder,
  value,
  onValueChange,
  onClear,
  disabled,
  isLoading,
  variant = 'medium',
  onKeyUp,
  isHeaderSearch,
  submitSearch,
}: Props) {
  const [searchValue, setSearchValue] = React.useState<string>(value);

  const onChange = (e: any) => {
    const value = e.target.value;
    setSearchValue(value);
    onValueChange(searchValue);
  };

  const clearSearch = () => {
    setSearchValue('');
    if (onClear) {
      onClear();
    }
  };

  return (
    <SearchContainer>
      {isHeaderSearch ? (
        <SearchBox>
          <CrossBox>
            <HeaderSearchComponent
              type="text"
              placeholder={placeholder}
              value={searchValue}
              onChange={onChange}
              disabled={disabled}
              variant={variant}
              onKeyUp={onKeyUp}
            />
            {searchValue && (
              <div className="header-Cross-svg" onClick={clearSearch}>
                <FontAwesomeIcon icon={isLoading ? faSpinner : faTimes} />
              </div>
            )}
          </CrossBox>
          <ButtonContainer onClick={submitSearch}>
            <div>
              <FontAwesomeIcon icon={faSearch} />
            </div>
          </ButtonContainer>
        </SearchBox>
      ) : (
        <>
          <div className="Search-svg">
            <FontAwesomeIcon icon={faSearch} />
          </div>
          <SearchComponent
            type="text"
            placeholder={placeholder}
            value={searchValue}
            onChange={onChange}
            disabled={disabled}
            variant={variant}
            onKeyUp={onKeyUp}
          />
          {searchValue && (
            <div className="Cross-svg" onClick={clearSearch}>
              <FontAwesomeIcon icon={isLoading ? faSpinner : faTimes} />
            </div>
          )}
        </>
      )}
    </SearchContainer>
  );
}
